
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3205',
  depVersions: {
  "customer-portal-app": "static-1.3205",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.10010",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26291",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5950",
  "hs-test-utils": "static-1.8396",
  "hub-http": "static-1.6572",
  "hub-http-shared-msw-handlers": "static-1.10710",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19080",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11851",
  "I18n": "static-7.1681",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6809",
  "payment-link-components": "static-1.24244",
  "portals-platform-bend-plugin": "static-1.23",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7526",
  "quartz-core": "static-1.6745",
  "quartz-i18n": "static-1.1201",
  "react": "static-7.199",
  "react-colorpicker": "static-2.10575",
  "react-dlb": "static-1.90",
  "react-utils": "static-2.5593",
  "reselect": "static-3.13",
  "rich-text-lib": "static-1.20388",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18453",
  "ui-components-test-utils": "static-1.5988",
  "UIComponents": "static-3.8797",
  "foundations-assets": "static-1.5246",
  "foundations-components": "static-1.8574",
  "foundations-theming": "static-1.4838",
  "foundations-theming-specialty": "static-1.2554",
  "framer-motion": "static-1.80",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1518",
  "quartz-config": "static-1.1304",
  "quartz-routing": "static-1.956",
  "quick-fetch": "static-1.4159",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-aeastham-remove-soft-nav-lcp-compat-fields.3",
  "rpc-client-utils": "static-1.5025",
  "sanitize-text": "static-1.8518",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.62",
  "ui-addon-draggable": "static-3.5106",
  "ui-addon-react-router-dom": "static-1.9892",
  "usage-tracker": "static-1.7673",
  "usage-tracker-anonymous": "static-1.6090",
  "usage-tracker-core": "static-1.7523",
  "video-components-external": "static-1.12242",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3803",
  "quartz-webpack": "static-1.3750",
  "bend-plugin-quartz-routing": "static-1.604",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.90",
  "customer-data-objects": "static-1.8048",
  "frontend-preferences-client": "static-1.8281",
  "laboratory-lib": "static-3.7513",
  "onboarding-scopes": "static-1.6813",
  "seat-types-lib": "static-1.816",
  "ui-addon-opt": "static-4.8714",
  "HeadJS": "static-2.805",
  "hs-test-utils-bend-plugin": "static-1.3507",
  "msw": "static-1.39",
  "testing-library": "static-1.159",
  "hs-locale-management": "static-1.331",
  "ts-schema": "static-1.4330",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8274",
  "content-media-capture": "static-1.5554",
  "cssUtils": "static-1.983",
  "customer-data-ui-utilities": "static-1.10191",
  "file-manager-components": "static-1.24615",
  "HubStyle": "static-2.12158",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3251",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.509",
  "ui-addon-emoji-picker": "static-1.10231",
  "ui-addon-i18n": "static-1.11508",
  "ui-business-units-lib": "static-1.9452",
  "ui-shepherd-react": "static-3.10632",
  "video-data-lib": "static-1.35900",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4672",
  "commerce-tours-lib": "static-1.6702",
  "customer-data-properties": "static-1.52752",
  "getting-started-shared-tasks": "static-1.19350",
  "growth-onboarding-reliability": "static-1.5442",
  "onboarding-tours": "static-1.17215",
  "reference-resolvers-lite": "static-1.8463",
  "sales-checkout-service-client": "static-1.3890",
  "ui-addon-iframeable": "static-1.9438",
  "user-context": "static-1.5470",
  "bender-build-tools": "static-1.3452",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.889",
  "hubspotter-http": "static-1.4895",
  "icons": "static-2.695",
  "mobile-manifest-mixins": "static-1.585",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.514",
  "quartz-auth": "static-1.1201",
  "quartz-head": "static-1.1191",
  "quartz-test": "static-1.1201",
  "quartz-tracking": "static-1.905",
  "trellis-components": "static-1.2805",
  "ui-fonts": "static-1.1113",
  "usage-tracker-container": "static-1.7663",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9785",
  "data-token-picker": "static-1.16964",
  "FileManagerLib": "static-1.40255",
  "property-translator": "static-1.5741",
  "merchandise-lib": "static-1.279",
  "purchase-motions-components": "static-1.6481",
  "SharedI18nStrings": "static-1.184",
  "foundations-components-test-utils": "static-1.6057",
  "react-create-root-preference": "static-1.80",
  "react-select-plus": "static-1.114",
  "react-virtualized": "static-2.108",
  "ui-images": "static-2.1265",
  "bend-plugin-foundations-components": "static-1.4843",
  "floating-ui": "static-1.64",
  "react-aria": "static-1.73",
  "trellis-assets": "static-1.2786",
  "bend-plugin-foundations-theming": "static-1.3321",
  "foundations-theming-base": "static-1.3823",
  "stylex": "static-1.42",
  "interframe": "static-3.5103",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6087",
  "opentelemetry-fe-types": "static-1.139",
  "web-vitals": "static-1.16",
  "bend-plugin-chirp-manifest": "static-1.435",
  "chirp-fetch": "static-1.2257",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4831",
  "react-flip-move": "static-1.79",
  "apollo-link-hub-http": "static-2.5006",
  "content-media-composition-data-lib": "static-1.13358",
  "content-media-compositions": "static-2.17365",
  "idb-keyval": "static-1.52",
  "immer": "static-1.102",
  "immerable": "static-1.4505",
  "magpie-lib": "static-1.5799",
  "magpie-types": "static-1.5259",
  "media-bridge-lib": "static-1.19481",
  "inbound-db-properties-service-client": "static-1.4083",
  "superstore": "static-1.5120",
  "feedback-loader": "static-1.29889",
  "ai-components-ui-library": "static-1.9829",
  "ui-addon-video-player": "static-1.9051",
  "ui-coaching-tips": "static-1.29408",
  "ContentUtils": "static-1.69233",
  "fix-webm-duration": "static-1.31",
  "notification-sounds": "static-1.4784",
  "sassPrefix": "static-1.250",
  "react-dnd-compat": "static-1.4975",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1880",
  "copilot-toolkit": "static-1.11942",
  "atom": "static-1.5441",
  "avatar-components": "static-1.2844",
  "navigation-messaging": "static-1.8259",
  "redux-thunk": "static-2.81",
  "reference-resolvers": "static-1.8542",
  "commerce-products-lib": "static-1.10653",
  "crm-message-bus": "static-1.43874",
  "growth-data-modal": "static-1.5971",
  "hubspot-apollo-client": "static-1.5235",
  "onboarding-tours-client": "static-1.5430",
  "batch-promise": "static-1.1905",
  "calling-global-api": "static-1.65798",
  "calling-internal-common": "static-1.31681",
  "calling-lifecycle-internal": "static-1.67180",
  "calling-lifecycle-messages": "static-1.59474",
  "conditional-properties-service-client": "static-1.4053",
  "crm-index-visualization-core": "static-1.4606",
  "crm-links": "static-1.6658",
  "crm-pipelines-api-client-types": "static-1.4384",
  "customer-data-objects-ui-components": "static-1.13391",
  "customer-data-properties-shared-msw-handlers": "static-1.10037",
  "customer-data-property-utils": "static-1.8447",
  "external-options-client-types": "static-1.4377",
  "formula-editor": "static-1.14852",
  "framework-data-schema-resolvers": "static-1.7254",
  "google-libphonenumber": "static-1.46",
  "hs-resources": "static-1.553",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4461",
  "meetings-icalendar-utils-lib": "static-1.995",
  "multi-currency-client-types": "static-1.3944",
  "object-builder-ui-client": "static-1.49799",
  "pipeline-validation-client-types": "static-1.4219",
  "property-value-citations": "static-1.3366",
  "pulse": "static-1.991",
  "smart-data-capture-core": "static-1.232",
  "smart-property-lib": "static-1.8414",
  "tiered-pricing": "static-1.2048",
  "topics-actions-lib": "static-1.531",
  "trial-components-library": "static-1.14198",
  "ui-addon-form-validation": "static-1.11332",
  "zustand": "static-1.86",
  "growth-onboarding-confetti": "static-1.3425",
  "growth-onboarding-next-action-utils": "static-1.2788",
  "navigation-components": "static-1.18932",
  "onboarding-tours-utils": "static-1.1282",
  "ui-shepherd-tracker": "static-1.8013",
  "ui-universal-auth": "static-1.9502",
  "getting-started-shared-tasks-store": "static-1.18468",
  "beacon-keepalive-queue": "static-1.65",
  "opentelemetry-web": "static-1.15",
  "hubspotter-http-shared-msw-handlers": "static-1.10708",
  "usage-tracker-session-replay": "static-1.5359",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "trellis-theming": "static-1.1334",
  "tanstack-virtual": "static-1.39",
  "audio-components": "static-1.6421",
  "FileManagerCore": "static-1.40114",
  "FileManagerImages": "static-1.37766",
  "video-components": "static-1.14244",
  "foundations-components-legacy": "static-1.1599",
  "purchase-motions-api": "static-1.6484",
  "signup-constants": "static-1.19714",
  "signup-ui-url-generator": "static-2.8419",
  "stylex-utils": "static-1.149",
  "usage-tracker-public": "static-1.7484",
  "reactive-lib": "static-1.1079",
  "simple-logging-lib": "static-1.3410",
  "nudge-client-utils": "static-1.3228",
  "chatspot-core": "static-1.23289",
  "growth-onboarding-feedback-components": "static-1.6946",
  "cms-field-types": "static-1.5171",
  "content-icons-ui": "static-1.2410",
  "integrations-lib": "static-1.17179",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.858",
  "breeze-engine-core": "static-1.1158",
  "ably": "static-2.2",
  "highlight.js": "static-1.87",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1137",
  "customer-data-tracking": "static-1.7230",
  "products-iframe-lib": "static-1.8683",
  "products-ui-components-shared-msw-handlers": "static-1.11092",
  "restore-request-side-panel-lib": "static-1.1776",
  "onboarding-data-sync-lib": "static-1.2611",
  "hubspot-apollo-cache": "static-1.694",
  "calling-error-reporting": "static-1.31688",
  "shared-worker-versioning": "static-1.11401",
  "calling-usage-tracker": "static-1.6896",
  "voice-sms-access-library": "static-1.2175",
  "conversations-skeleton-state": "static-1.7596",
  "crm-index-associations-lib": "static-1.6806",
  "framework-data-schema-quick-fetch": "static-1.7159",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10793",
  "redux-toolkit": "static-1.79",
  "sales-views-client-types": "static-1.4616",
  "location-customization-utils-lib": "static-1.10211",
  "bark-lib": "static-1.16878",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.103",
  "crm-properties-common-lib": "static-1.6250",
  "react-codemirror": "static-1.11003",
  "fdsr-migration-layer": "static-1.373",
  "framework-builder-read-service-client": "static-1.4258",
  "persist-promise": "static-1.4062",
  "event-emitter": "static-1.1318",
  "bend-plugin-pulse": "static-1.494",
  "fast-json-patch": "static-1.71",
  "data-agent-kit": "static-1.727",
  "fsm": "static-1.4114",
  "policy-lib": "static-1.7166",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10856",
  "embedded-academy-lib": "static-1.15689",
  "hubs-service-types": "static-1.1621",
  "salesImages": "static-1.622",
  "growth-onboarding-next-action-components": "static-1.2816",
  "user-context-client": "static-1.4869",
  "nest": "static-1.596",
  "unified-auth-core-lib": "static-1.1298",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.533",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.62",
  "urlinator": "static-1.4877",
  "video-embed": "static-1.36734",
  "social-insights-client-types": "static-1.22728",
  "nudge-custom-function-registry": "static-1.2985",
  "nudge-renderer-utils": "static-1.3304",
  "whisper-core-api": "static-1.7427",
  "flux-actions": "static-1.375",
  "integrations-error-boundary-lib": "static-1.14594",
  "integrations-tracking-lib": "static-1.5971",
  "native-integrations-shared-strings": "static-1.8126",
  "redux-observable": "static-1.76",
  "ReduxMessenger": "static-2.10732",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1016",
  "InboxConnectUtils": "static-4.15653",
  "meetings-connect-utils-lib": "static-1.7971",
  "calling-orchestration-schema": "static-1.36952",
  "crm-record-cards-service-types": "static-1.3803",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16460",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.112",
  "trellis-story-utils": "static-1.4867",
  "storybook-react": "static-1.41",
  "academy-common-lib": "static-1.15149",
  "outpost": "static-1.4500",
  "universal-page-editor-lib": "static-1.3369",
  "adobe-sign-auth-lib": "static-1.567",
  "ads-unified-auth-lib": "static-1.1567",
  "custom-vendor-connection-lib": "static-1.66",
  "google-sheets-integration-lib": "static-1.1130",
  "microsoft-drive-auth-lib": "static-1.266",
  "surveymonkey-integration-lib": "static-1.606",
  "slack-ui-library": "static-1.10758",
  "hub-http-contrib": "static-1.3388",
  "ui-addon-sales-email": "static-1.5562",
  "academy-service-client": "static-1.4052",
  "croppie": "static-2.10",
  "final-form": "static-1.79",
  "SafeStorage": "static-1.4754",
  "trellis-ecosystem": "static-1.7702",
  "wootric-nps": "static-1.7232",
  "marketplace-ui-apps-core": "static-1.19374",
  "marketplace-ui-common": "static-1.20842",
  "developer-experience-shared-components": "static-1.10897",
  "immutable-less": "static-1.5010",
  "marketplace-ui-client-types": "static-1.18249",
  "ui-addon-integrations-directory-panel": "static-2.8376",
  "ui-extensibility-client-types": "static-1.4277",
  "ai-settings-ui-library": "static-1.8419",
  "nav-meta": "static-1.30569",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1245",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4594",
  "settings-ui-lib": "static-1.12883",
  "simple-data-table": "static-1.3612"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3205",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.10010",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26291",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5950",
  "hs-test-utils": "/hs-test-utils/static-1.8396",
  "hub-http": "/hub-http/static-1.6572",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10710",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19080",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11851",
  "I18n": "/I18n/static-7.1681",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6809",
  "payment-link-components": "/payment-link-components/static-1.24244",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.23",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7526",
  "quartz-core": "/quartz-core/static-1.6745",
  "quartz-i18n": "/quartz-i18n/static-1.1201",
  "react": "/react/static-7.199",
  "react-colorpicker": "/react-colorpicker/static-2.10575",
  "react-dlb": "/react-dlb/static-1.90",
  "react-utils": "/react-utils/static-2.5593",
  "reselect": "/reselect/static-3.13",
  "rich-text-lib": "/rich-text-lib/static-1.20388",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18453",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5988",
  "UIComponents": "/UIComponents/static-3.8797",
  "foundations-assets": "/foundations-assets/static-1.5246",
  "foundations-components": "/foundations-components/static-1.8574",
  "foundations-theming": "/foundations-theming/static-1.4838",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2554",
  "framer-motion": "/framer-motion/static-1.80",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1518",
  "quartz-config": "/quartz-config/static-1.1304",
  "quartz-routing": "/quartz-routing/static-1.956",
  "quick-fetch": "/quick-fetch/static-1.4159",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-aeastham-remove-soft-nav-lcp-compat-fields.3",
  "rpc-client-utils": "/rpc-client-utils/static-1.5025",
  "sanitize-text": "/sanitize-text/static-1.8518",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.62",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5106",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9892",
  "usage-tracker": "/usage-tracker/static-1.7673",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6090",
  "usage-tracker-core": "/usage-tracker-core/static-1.7523",
  "video-components-external": "/video-components-external/static-1.12242",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3803",
  "quartz-webpack": "/quartz-webpack/static-1.3750",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.604",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.90",
  "customer-data-objects": "/customer-data-objects/static-1.8048",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8281",
  "laboratory-lib": "/laboratory-lib/static-3.7513",
  "onboarding-scopes": "/onboarding-scopes/static-1.6813",
  "seat-types-lib": "/seat-types-lib/static-1.816",
  "ui-addon-opt": "/ui-addon-opt/static-4.8714",
  "HeadJS": "/HeadJS/static-2.805",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3507",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.159",
  "hs-locale-management": "/hs-locale-management/static-1.331",
  "ts-schema": "/ts-schema/static-1.4330",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8274",
  "content-media-capture": "/content-media-capture/static-1.5554",
  "cssUtils": "/cssUtils/static-1.983",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10191",
  "file-manager-components": "/file-manager-components/static-1.24615",
  "HubStyle": "/HubStyle/static-2.12158",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3251",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.509",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10231",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11508",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9452",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10632",
  "video-data-lib": "/video-data-lib/static-1.35900",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4672",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6702",
  "customer-data-properties": "/customer-data-properties/static-1.52752",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19350",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5442",
  "onboarding-tours": "/onboarding-tours/static-1.17215",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8463",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3890",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9438",
  "user-context": "/user-context/static-1.5470",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.889",
  "hubspotter-http": "/hubspotter-http/static-1.4895",
  "icons": "/icons/static-2.695",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.514",
  "quartz-auth": "/quartz-auth/static-1.1201",
  "quartz-head": "/quartz-head/static-1.1191",
  "quartz-test": "/quartz-test/static-1.1201",
  "quartz-tracking": "/quartz-tracking/static-1.905",
  "trellis-components": "/trellis-components/static-1.2805",
  "ui-fonts": "/ui-fonts/static-1.1113",
  "usage-tracker-container": "/usage-tracker-container/static-1.7663",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9785",
  "data-token-picker": "/data-token-picker/static-1.16964",
  "FileManagerLib": "/FileManagerLib/static-1.40255",
  "property-translator": "/property-translator/static-1.5741",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "purchase-motions-components": "/purchase-motions-components/static-1.6481",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6057",
  "react-create-root-preference": "/react-create-root-preference/static-1.80",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-virtualized": "/react-virtualized/static-2.108",
  "ui-images": "/ui-images/static-2.1265",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4843",
  "floating-ui": "/floating-ui/static-1.64",
  "react-aria": "/react-aria/static-1.73",
  "trellis-assets": "/trellis-assets/static-1.2786",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3321",
  "foundations-theming-base": "/foundations-theming-base/static-1.3823",
  "stylex": "/stylex/static-1.42",
  "interframe": "/interframe/static-3.5103",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6087",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.139",
  "web-vitals": "/web-vitals/static-1.16",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.435",
  "chirp-fetch": "/chirp-fetch/static-1.2257",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4831",
  "react-flip-move": "/react-flip-move/static-1.79",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5006",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13358",
  "content-media-compositions": "/content-media-compositions/static-2.17365",
  "idb-keyval": "/idb-keyval/static-1.52",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4505",
  "magpie-lib": "/magpie-lib/static-1.5799",
  "magpie-types": "/magpie-types/static-1.5259",
  "media-bridge-lib": "/media-bridge-lib/static-1.19481",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4083",
  "superstore": "/superstore/static-1.5120",
  "feedback-loader": "/feedback-loader/static-1.29889",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9829",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9051",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29408",
  "ContentUtils": "/ContentUtils/static-1.69233",
  "fix-webm-duration": "/fix-webm-duration/static-1.31",
  "notification-sounds": "/notification-sounds/static-1.4784",
  "sassPrefix": "/sassPrefix/static-1.250",
  "react-dnd-compat": "/react-dnd-compat/static-1.4975",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1880",
  "copilot-toolkit": "/copilot-toolkit/static-1.11942",
  "atom": "/atom/static-1.5441",
  "avatar-components": "/avatar-components/static-1.2844",
  "navigation-messaging": "/navigation-messaging/static-1.8259",
  "redux-thunk": "/redux-thunk/static-2.81",
  "reference-resolvers": "/reference-resolvers/static-1.8542",
  "commerce-products-lib": "/commerce-products-lib/static-1.10653",
  "crm-message-bus": "/crm-message-bus/static-1.43874",
  "growth-data-modal": "/growth-data-modal/static-1.5971",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5235",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5430",
  "batch-promise": "/batch-promise/static-1.1905",
  "calling-global-api": "/calling-global-api/static-1.65798",
  "calling-internal-common": "/calling-internal-common/static-1.31681",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67180",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59474",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4053",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4606",
  "crm-links": "/crm-links/static-1.6658",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4384",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13391",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10037",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8447",
  "external-options-client-types": "/external-options-client-types/static-1.4377",
  "formula-editor": "/formula-editor/static-1.14852",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7254",
  "google-libphonenumber": "/google-libphonenumber/static-1.46",
  "hs-resources": "/hs-resources/static-1.553",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4461",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.995",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3944",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49799",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4219",
  "property-value-citations": "/property-value-citations/static-1.3366",
  "pulse": "/pulse/static-1.991",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.232",
  "smart-property-lib": "/smart-property-lib/static-1.8414",
  "tiered-pricing": "/tiered-pricing/static-1.2048",
  "topics-actions-lib": "/topics-actions-lib/static-1.531",
  "trial-components-library": "/trial-components-library/static-1.14198",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11332",
  "zustand": "/zustand/static-1.86",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3425",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2788",
  "navigation-components": "/navigation-components/static-1.18932",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1282",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8013",
  "ui-universal-auth": "/ui-universal-auth/static-1.9502",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18468",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.65",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10708",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5359",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "trellis-theming": "/trellis-theming/static-1.1334",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "audio-components": "/audio-components/static-1.6421",
  "FileManagerCore": "/FileManagerCore/static-1.40114",
  "FileManagerImages": "/FileManagerImages/static-1.37766",
  "video-components": "/video-components/static-1.14244",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1599",
  "purchase-motions-api": "/purchase-motions-api/static-1.6484",
  "signup-constants": "/signup-constants/static-1.19714",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8419",
  "stylex-utils": "/stylex-utils/static-1.149",
  "usage-tracker-public": "/usage-tracker-public/static-1.7484",
  "reactive-lib": "/reactive-lib/static-1.1079",
  "simple-logging-lib": "/simple-logging-lib/static-1.3410",
  "nudge-client-utils": "/nudge-client-utils/static-1.3228",
  "chatspot-core": "/chatspot-core/static-1.23289",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6946",
  "cms-field-types": "/cms-field-types/static-1.5171",
  "content-icons-ui": "/content-icons-ui/static-1.2410",
  "integrations-lib": "/integrations-lib/static-1.17179",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.858",
  "breeze-engine-core": "/breeze-engine-core/static-1.1158",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.87",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1137",
  "customer-data-tracking": "/customer-data-tracking/static-1.7230",
  "products-iframe-lib": "/products-iframe-lib/static-1.8683",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11092",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1776",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2611",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.694",
  "calling-error-reporting": "/calling-error-reporting/static-1.31688",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11401",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6896",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2175",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7596",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6806",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7159",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10793",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "sales-views-client-types": "/sales-views-client-types/static-1.4616",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10211",
  "bark-lib": "/bark-lib/static-1.16878",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.103",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6250",
  "react-codemirror": "/react-codemirror/static-1.11003",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.373",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4258",
  "persist-promise": "/persist-promise/static-1.4062",
  "event-emitter": "/event-emitter/static-1.1318",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.494",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "data-agent-kit": "/data-agent-kit/static-1.727",
  "fsm": "/fsm/static-1.4114",
  "policy-lib": "/policy-lib/static-1.7166",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10856",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15689",
  "hubs-service-types": "/hubs-service-types/static-1.1621",
  "salesImages": "/salesImages/static-1.622",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2816",
  "user-context-client": "/user-context-client/static-1.4869",
  "nest": "/nest/static-1.596",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1298",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.533",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.62",
  "urlinator": "/urlinator/static-1.4877",
  "video-embed": "/video-embed/static-1.36734",
  "social-insights-client-types": "/social-insights-client-types/static-1.22728",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2985",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3304",
  "whisper-core-api": "/whisper-core-api/static-1.7427",
  "flux-actions": "/flux-actions/static-1.375",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14594",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5971",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8126",
  "redux-observable": "/redux-observable/static-1.76",
  "ReduxMessenger": "/ReduxMessenger/static-2.10732",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1016",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15653",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7971",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36952",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3803",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16460",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.112",
  "trellis-story-utils": "/trellis-story-utils/static-1.4867",
  "storybook-react": "/storybook-react/static-1.41",
  "academy-common-lib": "/academy-common-lib/static-1.15149",
  "outpost": "/outpost/static-1.4500",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3369",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.567",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1567",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.66",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1130",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.266",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.606",
  "slack-ui-library": "/slack-ui-library/static-1.10758",
  "hub-http-contrib": "/hub-http-contrib/static-1.3388",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5562",
  "academy-service-client": "/academy-service-client/static-1.4052",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.79",
  "SafeStorage": "/SafeStorage/static-1.4754",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7702",
  "wootric-nps": "/wootric-nps/static-1.7232",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19374",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20842",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10897",
  "immutable-less": "/immutable-less/static-1.5010",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18249",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8376",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4277",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8419",
  "nav-meta": "/nav-meta/static-1.30569",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1245",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4594",
  "settings-ui-lib": "/settings-ui-lib/static-1.12883",
  "simple-data-table": "/simple-data-table/static-1.3612"
}
};
